// src/assets/data/cursos/cripto-blockchain/modulo-5.js
import banner from "../../../courses/module-2/img5.png";

const modulo5 = {
  courseId: "cripto-blockchain",
  id: "modulo-5",
  title: "🧩 MODULE 5: Web3 Security – Protect Your Crypto Assets",
  estimatedDuration: "1 hour 30 minutes",
  format: "Reading + knowledge check activity",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objectives",
      title: "🎯 Module objective",
      content: [
        "Understand how wallets work, what a seed phrase is, and how to avoid the main risks in the crypto ecosystem.",
      ],
    },
    {
      id: "wallet",
      navLabel: "What is a wallet?",
      title: "🔐 What is a wallet?",
      content: [
        {
          type: "paragraph",
          text: "A wallet is a digital tool that allows you to store, send, and receive cryptocurrencies.",
        },
        {
          type: "paragraph",
          text: "Types of wallets:",
        },
        {
          type: "table",
          headers: ["Type", "Description", "Example"],
          rows: [
            [
              "Custodial",
              "A third party, such as a company, stores your keys for you. You access it with a username and password.",
              "Binance, Bitso, etc.",
            ],
            [
              "Non-custodial",
              "Only you have full control. No one else can access your funds if you lose your key.",
              "MetaMask, Trust Wallet, Vesseo, etc.",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "⚠️ Important: If you lose access to a non-custodial wallet and you do not have a backup, no one will be able to help you recover your funds.",
        },
      ],
    },
    {
      id: "banco-vs-wallet",
      navLabel: "Wallet vs Bank",
      title: "🏦 Wallet vs Bank: What is the difference?",
      content: [
        {
          type: "paragraph",
          text: "Although both allow you to store and move money, a crypto wallet and a traditional bank work in very different ways:",
        },
        {
          type: "table",
          headers: ["Aspect", "Traditional bank", "Crypto wallet"],
          rows: [
            [
              "Control of money",
              "The bank has custody. It can freeze or block your account.",
              "You have 100% control. No one can move your money without your authorization.",
            ],
            [
              "Requirements to open an account",
              "Documentation, verification, credit history.",
              "Anyone can create a wallet. No identification is required.",
            ],
            [
              "Operating hours",
              "Monday to Friday, limited hours.",
              "24/7, without interruptions.",
            ],
            [
              "Fees",
              "Maintenance, transfer, and ATM fees.",
              "Depends on the network. Sometimes very low, with no hidden charges.",
            ],
            [
              "Privacy",
              "Your data is registered by the bank and may be shared with governments or companies.",
              "You do not need to share personal data to use a wallet.",
            ],
            [
              "Technical support",
              "You can call or go to a branch if you have a problem.",
              "In non-custodial wallets, you are your own bank. If you lose your keys, no one can help you.",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "🎯 Conclusion",
        },
        {
          type: "list",
          items: [
            "A bank offers convenience and protection, but it also controls your money.",
            "A crypto wallet gives you freedom, but it requires full responsibility.",
          ],
        },
      ],
    },
    {
      id: "seed-phrase",
      navLabel: "Seed phrase",
      title: "🧠 Seed phrase: your master key",
      content: [
        {
          type: "paragraph",
          text: "A seed phrase is a series of 12 or 24 words that represent your wallet. It is the most valuable thing in Web3.",
        },
        {
          type: "paragraph",
          text: "Golden rules:",
        },
        {
          type: "list",
          items: [
            "Write it on paper, not on your phone or in screenshots.",
            "Keep it in a safe place, with no digital access.",
            "Never share it with anyone.",
          ],
        },
      ],
    },
    {
      id: "custodial-vs-non-custodial",
      navLabel: "Custodial vs Non-Custodial",
      title: "🛡 Custodial vs Non-Custodial",
      content: [
        {
          type: "table",
          headers: ["Feature", "Custodial", "Non-Custodial"],
          rows: [
            ["Control of funds", "Company", "User"],
            [
              "Recovery if you forget access",
              "Possible",
              "Only with the seed phrase",
            ],
            [
              "Security",
              "High if you trust the company",
              "High with good precautions",
            ],
          ],
        },
      ],
    },
    {
      id: "riesgos",
      navLabel: "Common risks",
      title: "⚠️ Common risks in Web3 — and how to avoid them!",
      content: [
        {
          type: "paragraph",
          text: "🧪 1. Phishing – Scams designed to steal your keys",
        },
        {
          type: "list",
          items: [
            "They imitate real websites, such as MetaMask, so you enter your seed phrase.",
            "Real example: Users who fell for fake websites lost all their funds.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Avoid it: never enter your seed phrase on any website. Only use your official app.",
        },
        {
          type: "paragraph",
          text: "🕷️ 2. Malware – Programs that steal your information",
        },
        {
          type: "paragraph",
          text: "Most common types:",
        },
        {
          type: "list",
          items: [
            "Clipper malware: changes the copied address to the scammer’s address.",
            "Keylogger: records everything you type, including passwords.",
            "Fake extensions: disguised as useful tools, such as translators, but they spy on your activity.",
          ],
        },
        {
          type: "paragraph",
          text: "Real example: A fake Android app changed copied wallet addresses. Users did not notice until it was too late.",
        },
        {
          type: "paragraph",
          text: "✅ Avoid it: do not download unknown apps or extensions. Use antivirus protection.",
        },
        {
          type: "paragraph",
          text: "💨 3. Rug pulls – Fake projects that disappear with your money",
        },
        {
          type: "list",
          items: [
            "Famous case: The SQUID token, inspired by Squid Game, rose to $2,800 and then collapsed. The creators disappeared with the money.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Avoid it: research before investing. If it sounds too good to be true, it probably is.",
        },
        {
          type: "paragraph",
          text: "🧪 4. Fake links on social media",
        },
        {
          type: "list",
          items: [
            "They appear in Instagram, Telegram, Discord comments, and more.",
            "They pretend to be “technical support.”",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Avoid it: never enter your data through links received by direct message. Only contact official support.",
        },
      ],
    },
    {
      id: "practicas",
      navLabel: "Best practices",
      title: "🔒 Security best practices",
      content: [
        {
          type: "orderedList",
          items: [
            "Enable two-factor authentication (2FA) whenever possible.",
            "Never share your seed phrase.",
            "Use official wallets and download them from verified stores.",
            "Do not store keys in email or cloud storage.",
            "Double-check before confirming transactions.",
          ],
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Activity",
      title: "📝 Module activity",
      content: [
        {
          type: "paragraph",
          text: "Part 1: Best practices list",
        },
        {
          type: "list",
          items: [
            "Open a new document in Google Docs.",
            "Write a list of your 5 personal security rules for the crypto world.",
            "Example title: “My Web3 Survival Manual”",
          ],
        },
        {
          type: "paragraph",
          text: "Part 2: Simulation",
        },
        {
          type: "paragraph",
          text: "Briefly answer in the same document:",
        },
        {
          type: "list",
          items: [
            "What would you do if you lost your phone with your non-custodial wallet installed, such as Vesseo or Trust Wallet?",
            "What steps would you take to protect your funds or try to recover them?",
          ],
        },
      ],
    },
    {
      id: "recursos",
      navLabel: "Recommended resources",
      title: "📌 Recommended resources",
      content: [
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/how-to-secure-your-cryptocurrency",
          text: "Binance Academy – Crypto Security",
        },
        {
          type: "link",
          href: "https://www.bitpanda.com/academy/es/lecciones/como-puedo-mantener-mis-criptomonedas-seguras/",
          text: "Bitpanda – Keep your crypto safe",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Quote of the day",
      title: "🧠 Quote of the day",
      content: [
        "“In Web3, there are no banks. No bosses. Only you. And that means freedom… but also responsibility.”",
      ],
    },
  ],
};

export default modulo5;
